"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
const zodMMDashDDString = zod_1.z
    .string()
    .regex(/^(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/, 'Must be in MM-DD format (e.g. 02-14)')
    .nullable();
const zodContactMethods = zod_1.z
    .array(zod_1.z.enum(['email', 'sms']))
    .min(1)
    .max(2)
    .nonempty()
    .refine((arr) => new Set(arr).size === arr.length, { message: 'Array contains duplicate values' });
const newAlertSchema = zod_1.z.object({
    blockIds: zod_1.z.array(zod_1.z.number()).nullable(),
    hourOfDay: zod_1.z.string().regex(/^([01][0-9]|2[0-3])$/, 'Must be in HH format (00-23)'),
    name: zod_1.z.string().max(150),
    notifyOwnerByEmail: zod_1.z.boolean(),
    notifyOwnerBySMS: zod_1.z.boolean(),
    propertyIds: zod_1.z.array(zod_1.z.number()).nullable(),
    startDate: zodMMDashDDString,
    endDate: zodMMDashDDString,
    stationGeoms: zod_1.z.array(zod_1.z.string()).nullable(),
    contacts: zod_1.z
        .array(zod_1.z.object({
        contactId: zod_1.z.string(),
        contactMethods: zodContactMethods,
    }))
        .nullable(),
    groups: zod_1.z
        .array(zod_1.z.object({
        groupId: zod_1.z.number(),
        contactMethods: zodContactMethods,
    }))
        .nullable(),
    alertRules: zod_1.z.union([
        zod_1.z.object({
            windGreaterThanOrEqualToKph: zod_1.z.number(),
        }),
        zod_1.z.object({
            includeAllDevices: zod_1.z.boolean(),
            measurementHeights: zod_1.z.array(zod_1.z.enum(['aboveCanopyTemperature', 'inCanopyTemperature'])),
            temperatureLessThanOrEqualToCelsius: zod_1.z.number(),
        }),
        zod_1.z.object({
            includeAllDevices: zod_1.z.boolean(),
            measurementHeights: zod_1.z.array(zod_1.z.enum(['aboveCanopyTemperature', 'inCanopyTemperature'])),
            temperatureGreaterThanOrEqualToCelsius: zod_1.z.number(),
        }),
        zod_1.z.object({
            hasRain: zod_1.z.literal(true),
        }),
    ]),
});
exports.requestSchema = zod_1.z
    .object({
    legacyWeatherForecastAlertsToUpdate: zod_1.z.record(zod_1.z.string(), newAlertSchema).optional(),
    legacyWeatherForecastAlertsToDelete: zod_1.z.array(zod_1.z.number()).optional(),
    legacyWeatherForecastAlertsToCreate: zod_1.z.array(newAlertSchema).optional(),
})
    .refine((args) => !!Object.keys(args).length, {
    message: 'Request object must contain at least one argument',
});
exports.path = '/legacy-weather-forecast-alerts-management';
//# sourceMappingURL=index.js.map